import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import {Provider} from 'react-redux'
import store from './redux/store';

ReactDOM.render(
  <Provider store={store} >
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </Provider>,
  document.querySelector('#root')
);
